import { updateLocationSearch } from 'app/functions';
import { removeBikesFromProducts } from 'app/store/reducers/product';
import { ThunkType } from 'app/hooks/appHooks';

export const removeBikes = (): ThunkType<void> => (dispatch) => {
  dispatch(removeBikesFromProducts());
  const urlParams = new URLSearchParams(window.location.search);

  urlParams.delete('bike_slot');

  updateLocationSearch(urlParams);
};
